// extracted by mini-css-extract-plugin
export default {"wrapper":"app_wrapper__afBTz","main":"app_main__rmRZz"};